export const deptOption = {
    name: '部门',
    prop: 'deptName',
    value: 'deptName',
    type: 'advance',
    isFixed: true,
    span: 3,
    advanceConfig: [
        { 'prop': 'deptName', 'value': '部门名称' },
        { 'prop': 'deptCode', 'value': '部门编码' }
    ],
    tableConfig: [
        { 'prop': 'deptCode', 'value': '部门编码' },
        { 'prop': 'deptName', 'value': '部门名称', 'displayName': 'deptName' }
    ],
    method: 'post',
    prefix: '/api-lcrm',
    advanceUrl: '/goal/manage/dept/page',
    cbParams: ['deptCode', 'deptName'],
    advanceCode: 'advanceCode'
};

export const groupOption = {
    name: '分组',
    value: 'groupName',
    type: 'advanceMulti',
    isFixed: true,
    span: 4,
    advanceConfig: [
        { prop: 'groupName', value: '分组名称' }
    ],
    tableConfig: [
        { prop: 'groupName', value: '分组名称', 'displayName': 'groupName' },
        { prop: 'kpiNameSet', value: '关联指标' }
    ],
    method: 'post',
    prefix: '/api-lcrm',
    advanceUrl: '/goal/manage/groupDtoList',
    cbParams: ['groupIdSet', 'groupName']
};
